import Image from "next/image";
import Link from "next/link";
import googleDrive from "@/assets/images/icons/integrations/google-drive.svg";
import slack from "@/assets/images/icons/integrations/slack.svg";
import jira from "@/assets/images/icons/integrations/jira.svg";
import confluence from "@/assets/images/icons/integrations/confluence.svg";
import notion from "@/assets/images/icons/integrations/notion.svg";
import github from "@/assets/images/icons/integrations/github.svg";
import salesforce from "@/assets/images/icons/integrations/salesforce.svg";
import freshdesk from "@/assets/images/icons/integrations/freshdesk.svg";
import asana from "@/assets/images/icons/integrations/asana.svg";
import linear from "@/assets/images/icons/integrations/linear.svg";
import intercom from "@/assets/images/icons/integrations/intercom.svg";
import onedrive from "@/assets/images/icons/integrations/onedrive.svg";
import microsoftOutlook from "@/assets/images/icons/integrations/microsoft-outlook.svg";
import gmail from "@/assets/images/icons/integrations/gmail.svg";
import connectorsBgImage from "@/assets/images/advertisement/bg-ad-banner.svg";
import CustomButton from "../common/CustomButton";

const connectorsList = [
  { title: "Google Drive", icon: googleDrive, href: "/integrations/google-drive" },
  { title: "Slack", icon: slack, href: "/integrations/slack" },
  { title: "Jira", icon: jira, href: "/integrations/jira" },
  { title: "Confluence", icon: confluence, href: "/integrations/confluence" },
  { title: "Notion", icon: notion, href: "/integrations/notion" },
  { title: "GitHub", icon: github, href: "/integrations/github" },
  { title: "Salesforce", icon: salesforce, href: "/integrations/salesforce" },
  { title: "Freshdesk", icon: freshdesk, href: "/integrations/freshservice" },
  { title: "Asana", icon: asana, href: "/integrations/asana" },
  { title: "Linear", icon: linear, href: "/integrations/linear" },
  { title: "Intercom", icon: intercom, href: "/integrations/intercom" },
  { title: "OneDrive", icon: onedrive, href: "/integrations/one-drive" },
  { title: "Outlook", icon: microsoftOutlook, href: "/integrations/microsoft-outlook" },
  { title: "Gmail", icon: gmail, href: "/integrations/gmail" },
];

const Connectors = () => {
  return (
    <section className="relative z-10 overflow-hidden py-12 xl:py-20">
      <div
        className="absolute left-0 top-0 -z-10 h-full w-full"
        style={{
          backgroundImage: `url(${connectorsBgImage.src})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8 lg:mb-8 mb-12">
        <div>
        <h2 className="text-[24px] lg:text-[32px] mb-2 lg:mb-4 text-left mx-auto max-w-[800px] font-semibold text-[#FFFFFF]">
              100+ Connectors.
            One Search.
          </h2>
          <p className="max-w-[800px] mx-auto text-left text-[#FFFFFF]">
            Kroolo indexes and understands your data everywhere it lives. Native,
            secure integrations.
          </p>
        </div>
        <div className="lg:mt-0 mt-8">
          <CustomButton
            text="View All Connectors"
            url="/integrations"
            variant="primary"
            version="black"
          />
        </div>
        </div>

        <div className="mx-auto grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:gap-4 xl:grid-cols-7">
          {connectorsList.map((item) => (
            <Link
              key={item.title}
              href={item.href}
              className="rounded-[12px] border border-[#EBEDF2] bg-white px-3 py-4 text-center transition-all duration-200 hover:-translate-y-[2px] hover:border-[#D9DDF2] hover:shadow-sm"
            >
              <Image
                src={item.icon}
                alt={`${item.title} icon`}
                className="mx-auto mb-3 h-[36px] w-[36px] lg:h-[48px] lg:w-[48px] object-contain"
              />
              <p className="text-[16px] font-semibold text-[#202020]">{item.title}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Connectors;
